import React, { useState, useEffect } from "react";
import { MainInput } from "../../../mainComponent/mainInput";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import days from "../../../data/days.json";
import Toaster from "../../Toaster";
import "react-toastify/dist/ReactToastify.css";
import { ExpandMore } from "@mui/icons-material";
import { setHelperData } from "../../../recoil/atom/setHelperData";
import { useRecoilState } from "recoil";
import UserLinks from "../partial/uselinks";
import { Wrapper } from "../../../mainComponent/Wrapper";
import { MainNav } from "../../../mainComponent/mainNav";
import TouristAppointmentsApi from "../../../services/TouristAppointmentsApi";
import { MainSelect } from "../../../mainComponent/mainSelect";
import axios from "axios";
import { API } from "../../../config";
import { validateForm } from "../validateForm";
import { THEME_COLOR } from "../../../config";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function AddPackages() {
  const { doctorId } = useParams();
  const [helpersData, setHelpersData] = useRecoilState(setHelperData);
  const [activity, setActivity] = useState([]);
  const [packages, setPackages] = useState([]);
  const [daysData, setDaysData] = useState([]); // Will store all activities in format: [{activity: "", details: {}}, ...]
  const [selectedDays, setSelectedDays] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [showData, setShowData] = useState(false);
  const [file, setFile] = useState(null);
  const [editorData, setEditorData] = useState("<p>Initial content</p>");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const { saveTourismPackages, getActivities, GetAllPackageTypes } =
    TouristAppointmentsApi();

  useEffect(() => {
    getActivityTypes();
    getAllPackages();
  }, [selectedItem]);

  const handleFileChange = (event) => {
    setFile(event.target.files);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPackageData({ ...packageData, [name]: value });
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data); // Update the state with editor data
  };

  const getActivityTypes = () => {
    getActivities().then((res) => {
      setActivity(res);
    });
  };

  const getAllPackages = () => {
    GetAllPackageTypes().then((res) => {
      setPackages(res);
    });
  };

  const handleDaysChange = (event) => {
    const value = event.target.value;
    setSelectedDays(value);
    setShowData(true);
    // Initialize with empty activities array for each day
    const initialDaysData = Array.from({ length: value }).map(() => ({
      activities: [], // Will store all activities for this day
    }));
    setDaysData(initialDaysData);
  };

  const addActivity = (dayIndex) => {
    const updatedDaysData = [...daysData];
    if (!updatedDaysData[dayIndex].activities) {
      updatedDaysData[dayIndex].activities = [];
    }
    updatedDaysData[dayIndex].activities.push({
      activity: "",
      details: {},
    });
    setDaysData(updatedDaysData);
  };

  const handleActivityChange = (e, dayIndex, activityIndex) => {
    const value = e.target.value;
    const newDaysData = [...daysData];

    // Update the activity name
    newDaysData[dayIndex].activities[activityIndex].activity = value;

    // Fetch and update activity details as object with empty strings
    const selectedActivity = activity.find(
      (item) => item.activity_name === value,
    );
    if (selectedActivity) {
      const detailsObj = {};
      selectedActivity.activity_details.forEach((key) => {
        detailsObj[key] = ""; // Initialize with empty string for each key
      });
      newDaysData[dayIndex].activities[activityIndex].details = detailsObj;
    }

    setDaysData(newDaysData);
  };

  const handleSelectData = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setSelectedItem(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const validation = validateForm({
      packageData,
      selectedDays,
      selectedItem,
      file,
    });

    if (!validation.formIsValid) {
      setErrors(validation.errors);
      return;
    }

    // Prepare the data for the API - already in correct format
    const activitiesPerDay = daysData.map((day) => ({
      activities: day.activities.map((activity) => ({
        activity: activity.activity,
        details: activity.details,
      })),
    }));

    const bodyData = {
      doctorId: doctorId,
      packagename: packageData.packagename,
      excerpt: packageData.shortdescription,
      description: packageData.description,
      packageprice: selectedItem,
      activitiesperday: activitiesPerDay,
      noofdays: selectedDays,
    };

    try {
      await saveTourismPackages(bodyData).then(async (res) => {
        const formData = new FormData();
        if (file) {
          Array.from(file).forEach((singleFile) =>
            formData.append("photo", singleFile),
          );
          try {
            await axios.post(`${API}/updatepackageImg/${res._id}`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            alert("File uploaded successfully");
          } catch (error) {
            console.error(
              "Error uploading files",
              error.response ? error.response.data : error.message,
            );
          }
        }
      });
      navigate(`/tourism/${doctorId}`);
    } catch (error) {
      console.error("Error saving package:", error);
    }
  }

  return (
    <Wrapper>
      <MainNav>
        <ul className="clearfix">
          <li>
            <Link to={`/tourism/${doctorId}`}>
              <i className="arrow_back backArrow" title="back button"></i>
            </Link>
          </li>
          <li className="float-none" style={{ fontSize: "inherit" }}>
            Add package
          </li>
        </ul>
      </MainNav>
      <div className="row ">
        <div className="width_16">
          <div className="dash row">
            <UserLinks
              doctorId={doctorId}
              helperId={helpersData._id}
              accessModule={helpersData.access_module}
            />
          </div>
        </div>

        <div className="width_84">
          <form encType="multipart/form-data" onSubmit={handleSubmit}>
            <div className="white-box">
              <div className="row p-2">
                <div className="col-lg-5 ">
                  <label
                    htmlFor="name"
                    className="helperLabel font_weight float-left"
                  >
                    Package Name*
                  </label>
                  <MainInput
                    type="text"
                    name="packagename"
                    value={packageData.packagename}
                    onChange={handleChange}
                    placeholder="Enter Package Name"
                  ></MainInput>
                  {errors.packagename && (
                    <div className="validation">{errors.packagename}</div>
                  )}

                  <div>
                    <label
                      htmlFor="email"
                      className="helperLabel font_weight float-left"
                    >
                      Package Plan*
                    </label>
                  </div>

                  <MainSelect value={selectedItem} onChange={handleSelectData}>
                    <option value="">select Plan</option>
                    {packages &&
                      packages.map((item, index) => (
                        <option
                          key={index}
                          value={item.packageName}
                          className="form-control"
                        >
                          {item.packageName}
                        </option>
                      ))}
                  </MainSelect>
                  {errors.selectedItem && (
                    <div className="validation mt-2">{errors.selectedItem}</div>
                  )}
                  <div>
                    <label
                      htmlFor="password"
                      className="helperLabel font_weight float-left"
                    >
                      Package Description*
                    </label>
                  </div>
                  <div>
                    <textarea
                      type="text"
                      name="shortdescription"
                      value={packageData.shortdescription}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="short description"
                    />
                  </div>
                  {errors.shortdescription && (
                    <div className="validation mt-2">
                      {errors.shortdescription}
                    </div>
                  )}
                  <div className="mt-2">
                    <textarea
                      type="text"
                      name="description "
                      value={packageData.description}
                      onChange={handleChange}
                      className="form-control "
                      placeholder="long description"
                    />
                  </div>
                  {/* <CKEditor
                                        editor={ClassicEditor}
                                        data={editorData}
                                        config={{
                                            toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList'],
                                        }}
                                        onChange={handleEditorChange}
                                    />
                                    <div dangerouslySetInnerHTML={{ __html: editorData }} /> */}
                  <div className="mt-2">
                    <label className="helperLabel font_weight float-left">
                      Upload Photos
                    </label>
                    <MainInput
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={handleFileChange}
                      name="photo"
                      multiple
                    />
                    {errors.file && (
                      <div className="validation">{errors.file}</div>
                    )}
                    {/* <span>You can only upload a maximum of 2 files.</span> */}
                  </div>
                </div>
                {/* adding per day C */}
                <div className="col-lg-5">
                  <div className="helperDiv mb-3">
                    <label
                      htmlFor="mobile"
                      className="helperLabel font_weight float-left"
                    >
                      No. Of Days*
                    </label>
                    <MainSelect
                      name="selectedDays"
                      value={selectedDays}
                      onChange={handleDaysChange}
                    >
                      <option value="">Select Days</option>
                      {days &&
                        days.map((item, index) => (
                          <option
                            key={index}
                            value={item._id}
                            className="form-control"
                          >
                            {item.number}
                          </option>
                        ))}
                    </MainSelect>
                  </div>
                  {showData ? (
                    <>
                      {Array.from({ length: selectedDays }).map((_, index) => (
                        <div className="helperDiv" key={index}>
                          <Accordion defaultActiveKey="0">
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              aria-controls="calendar-content"
                              id={`calendar-header-${index}`}
                            >
                              Day {index + 1}
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="mb-3">
                                <label
                                  htmlFor="mobile"
                                  className="helperLabel font_weight float-left"
                                >
                                  Add Activities
                                </label>
                                <Link
                                  to="#"
                                  className="float-right"
                                  onClick={() => addActivity(index)}
                                >
                                  <AddCircleIcon
                                    style={{
                                      fontSize: 25,
                                      color: THEME_COLOR,
                                      marginLeft: 5,
                                      marginTop: 5,
                                    }}
                                  />
                                </Link>
                              </div>

                              {/* Render all activities for this day */}
                              {daysData[index]?.activities?.map(
                                (activityItem, activityIndex) => (
                                  <div key={activityIndex} className="mb-3">
                                    <div className="mb-3">
                                      <MainSelect
                                        value={activityItem.activity || ""}
                                        onChange={(e) =>
                                          handleActivityChange(
                                            e,
                                            index,
                                            activityIndex,
                                          )
                                        }
                                      >
                                        <option value="">
                                          Select Activity
                                        </option>
                                        {activity &&
                                          activity.map(
                                            (item, activityMapIndex) => (
                                              <option
                                                key={activityMapIndex}
                                                value={item.activity_name}
                                                className="form-control"
                                              >
                                                {item.activity_name}
                                              </option>
                                            ),
                                          )}
                                      </MainSelect>
                                    </div>

                                    {/* Render activity details */}
                                    {activityItem.details &&
                                      Object.keys(activityItem.details).length >
                                        0 && (
                                        <div className="activity-details mt-2">
                                          {Object.entries(
                                            activityItem.details,
                                          ).map(([key, value], detailIndex) => (
                                            <div
                                              key={detailIndex}
                                              className="mb-2"
                                            >
                                              <label className="helperLabel float-left">
                                                {key.replace(/_/g, " ")}:
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={value}
                                                onChange={(e) => {
                                                  const newDaysData = [
                                                    ...daysData,
                                                  ];
                                                  newDaysData[index].activities[
                                                    activityIndex
                                                  ].details[key] =
                                                    e.target.value;
                                                  setDaysData(newDaysData);
                                                }}
                                                placeholder={`Enter ${key.replace(/_/g, " ")}`}
                                              />
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                  </div>
                                ),
                              )}
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {errors.selectedDays && (
                        <div align="right" className="validation">
                          {errors.selectedDays}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="text-center add_top_30 pb-2">
                <MainButtonInput>Save</MainButtonInput>
              </div>
            </div>
          </form>
          <div className="row float-right toaster">
            <Toaster />
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
